import React from 'react'

const DotPattern = ({color}) => {
  return (
    <svg className='w-[249px]' xmlns="http://www.w3.org/2000/svg" 
    version="1.1"  
    viewBox="15 15 800 800" 
    opacity="1" 
    width="100" 
    height="100">
        <g stroke-width="6.75" stroke={color} fill="none">
            <circle r="16" cx="0" cy="0" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="133.33333333333334" cy="0" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="266.6666666666667" cy="0" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="400" cy="0" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="533.3333333333334" cy="0" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="666.6666666666667" cy="0" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="800.0000000000001" cy="0" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="0" cy="200" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="133.33333333333334" cy="200" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="266.6666666666667" cy="200" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="400" cy="200" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="533.3333333333334" cy="200" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="666.6666666666667" cy="200" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="800.0000000000001" cy="200" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="0" cy="400" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="133.33333333333334" cy="400" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="266.6666666666667" cy="400" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="400" cy="400" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="533.3333333333334" cy="400" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="666.6666666666667" cy="400" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="800.0000000000001" cy="400" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="0" cy="600" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="133.33333333333334" cy="600" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="266.6666666666667" cy="600" fill={color} stroke="none">
                </circle>
            <circle r="16" cx="400" cy="600" fill={color} stroke="none"></circle><circle r="16" cx="533.3333333333334" cy="600" fill={color} stroke="none"></circle><circle r="16" cx="666.6666666666667" cy="600" fill={color} stroke="none"></circle><circle r="16" cx="800.0000000000001" cy="600" fill={color} stroke="none"></circle><circle r="16" cx="0" cy="800" fill={color} stroke="none"></circle><circle r="16" cx="133.33333333333334" cy="800" fill={color} stroke="none"></circle><circle r="16" cx="266.6666666666667" cy="800" fill={color} stroke="none"></circle><circle r="16" cx="400" cy="800" fill={color} stroke="none"></circle><circle r="16" cx="533.3333333333334" cy="800" fill={color} stroke="none"></circle><circle r="16" cx="666.6666666666667" cy="800" fill={color} stroke="none"></circle><circle r="16" cx="800.0000000000001" cy="800" fill={color} stroke="none"></circle></g></svg>
  )
}

export default DotPattern

